import React, { useState } from 'react';
import Button from './Button';
import SubscriptionForm from './SubscriptionForm';

interface PricingFeature {
  name: string;
  included: boolean;
}

interface PricingCardProps {
  title: string;
  price: string;
  description: string;
  features: PricingFeature[];
  popular?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  description,
  features,
  popular = false,
}) => {
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);

  return (
    <>
      <div className={`bg-light rounded-lg overflow-hidden transition-all duration-300 ${
        popular ? 'shadow-custom-hover border-2 border-[#1b4f72] scale-105' : 'shadow-custom hover:shadow-custom-hover'
      }`}>
        <div className="p-6 sm:p-8">
          <h3 className="font-abadi text-xl font-medium mb-2">{title}</h3>
          <div className="flex items-baseline mb-4">
            <span className="font-abadi text-3xl font-medium">{price}</span>
            <span className="text-dark-gray ml-2">of rental income</span>
          </div>
          <p className="text-dark-gray mb-6">{description}</p>
          <div className="space-y-4 mb-8">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start">
                <span className={`w-4 flex-shrink-0 mt-0.5 font-bold ${
                  feature.included ? 'text-[#3087cf]' : 'text-error'
                }`}>
                  {feature.included ? '✓' : '×'}
                </span>
                <span className="ml-3 text-dark-gray">{feature.name}</span>
              </div>
            ))}
          </div>
          <Button
            variant="custom"
            className="w-full bg-[#f0ffb2] hover:bg-[#f0ffb2]/90 text-dark"
            onClick={() => setShowSubscriptionForm(true)}
          >
            Get Started
          </Button>
        </div>
      </div>

      {showSubscriptionForm && (
        <SubscriptionForm
          onClose={() => setShowSubscriptionForm(false)}
          planTitle={title}
        />
      )}
    </>
  );
};

export default PricingCard;